import { render, staticRenderFns } from "./ThreeHospital.vue?vue&type=template&id=1dfbafdf&scoped=true&"
import script from "./ThreeHospital.vue?vue&type=script&lang=js&"
export * from "./ThreeHospital.vue?vue&type=script&lang=js&"
import style0 from "./ThreeHospital.vue?vue&type=style&index=0&id=1dfbafdf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfbafdf",
  null
  
)

export default component.exports